export default "__VITE_ASSET__Ck$V6O_y__"